import React from "react";
import { Navigation, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const servicedCities = ["Olive Hill, KY", "Morehead, KY", "Grayson, KY", "Ashland, KY", "Maysville, KY", "Portsmouth, OH", "Vanceburg, KY", "Flemingsburg, KY"];
export default function OurServiceArea() {
  return <section id="our-service-area" className="w-full bg-background py-16 lg:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-stretch">
          
          <div className="lg:col-span-5 flex flex-col justify-center order-2 lg:order-1">
            <Card className="h-full flex flex-col justify-center border-border shadow-lg bg-card">
              <CardHeader className="pb-4">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 text-primary w-fit mb-4 text-sm font-semibold tracking-wide uppercase">
                  <Navigation className="w-4 h-4" />
                  Regional Coverage
                </div>
                <CardTitle className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
                  Our Service Area
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-8">
                <p className="text-muted-foreground text-base md:text-lg leading-relaxed">Headquartered in Roxboro, North Carolina, Olive Hill Equipment Service provides comprehensive in-shop repairs. We ensure your Miller, Lincoln, and Hypertherm equipment stays operational with minimal downtime.</p>

                <div className="pt-2">
                  <Button asChild size="lg" className="w-full sm:w-auto">
                    <Link to="/RequestServicePage">
                      Request On-Site Service
                    </Link>
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="lg:col-span-7 relative min-h-[400px] lg:min-h-[600px] rounded-2xl overflow-hidden border border-border bg-muted order-1 lg:order-2 shadow-xl">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3218.4215286591!2d-78.998388923415!3d36.411666672459!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89ad07667f479e09%3A0x67341257444736f!2s1940%20Semora%20Rd%2C%20Roxboro%2C%20NC%2027574!5e0!3m2!1sen!2sus!4v1740673456789!5m2!1sen!2sus" className="absolute inset-0 w-full h-full border-0" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Our Service Area Map"></iframe>
          </div>

        </div>
      </div>
    </section>;
}